module.exports = __webpack_public_path__ + "2e5f7a009157a836cdebd91b6236f7e9.png";